export default __webpack_public_path__ + "images/online-payment/master-card-electronic.svg?719f1e2eac33ac3e8f71a567aeb22105e9a072104a589ba8d0d5d7bafd936b6d";